// extracted by mini-css-extract-plugin
export default {"masthead":"Masthead-module_masthead__jHRgM","contain":"Masthead-module_contain__Gtyar","kicker":"Masthead-module_kicker__L0XNK"};